module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "booking-summary-callout policy-callout"
  }, [_c('strong', {
    staticClass: "callout-title"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "viewBox": "0 0 14 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M7 2.3c3.14 0 5.7 2.56 5.7 5.7s-2.56 5.7-5.7 5.7A5.71 5.71 0 0 1 1.3 8c0-3.14 2.56-5.7 5.7-5.7zM7 1C3.14 1 0 4.14 0 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm1 3H6v5h2V4zm0 6H6v2h2v-2z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("\n            Booking Policy\n        ")])]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.policy)
    }
  }), _vm._v(" "), _c('fieldset', [_c('input-checkbox', {
    ref: "checkbox",
    attrs: {
      "label": _vm.policyMessage,
      "required": "true"
    },
    on: {
      "change": _vm.toggle
    }
  }), _vm._v(" "), (_vm.validationErr) ? _c('div', {
    staticClass: "input__validation-error-msg"
  }, [_vm._v("\n        " + _vm._s(_vm.validationErrMsg) + "\n      ")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd033254","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bookingPolicy.vue
// module id = 619
// module chunks = 0